import React, { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight, Loader2 } from "lucide-react";
import { loadPdfDocument } from "../utils/pdfWorker";

export const PdfDocumentPreview = ({ doc }) => {
  const [pdf, setPdf] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [error, setError] = useState("");
  const [rendering, setRendering] = useState(true);
  const canvasRef = useRef(null);
  useEffect(() => {
    let alive = true;
    setPdf(null); setPageNumber(1); setError(""); setRendering(true);
    // Not: paylaşımlı pdf.js worker'ı yok etmemek için doküman destroy EDİLMEZ (bkz. utils/pdfWorker.js)
    loadPdfDocument(doc.output("arraybuffer"))
      .then(value => {
        if (alive) setPdf(value);
      })
      .catch(e => { if (alive) { setError(e.message); setRendering(false); } });
    return () => { alive = false; };
  }, [doc]);
  useEffect(() => {
    if (!pdf) return;
    let cancelled = false, renderTask;
    setRendering(true);
    pdf.getPage(pageNumber).then(page => {
      if (cancelled || !canvasRef.current) return;
      const viewport = page.getViewport({ scale: 1.7 });
      const canvas = canvasRef.current;
      canvas.width = viewport.width; canvas.height = viewport.height;
      renderTask = page.render({ canvasContext: canvas.getContext("2d"), viewport });
      return renderTask.promise;
    }).then(() => { if (!cancelled) setRendering(false); }).catch(e => {
      if (!cancelled && e.name !== "RenderingCancelledException") { setError(e.message); setRendering(false); }
    });
    return () => { cancelled = true; renderTask?.cancel(); };
  }, [pdf, pageNumber]);
  return <div className="w-full min-w-0" data-testid="tailor-pdf-viewer">
    <div className="sticky top-0 z-10 flex items-center justify-center gap-3 py-2 bg-slate-200 dark:bg-[#0C1220]">
      <button data-testid="tailor-previous-page" aria-label="Önceki sayfa" title="Önceki sayfa" disabled={!pdf || pageNumber <= 1 || rendering} onClick={() => setPageNumber(p => p - 1)} className="p-1.5 rounded hover:bg-slate-300 dark:hover:bg-slate-700 disabled:opacity-30 transition-colors"><ChevronLeft className="w-4 h-4" /></button>
      <span data-testid="tailor-page-count" className="text-xs tabular-nums font-semibold">{pageNumber} / {pdf?.numPages || "…"}</span>
      <button data-testid="tailor-next-page" aria-label="Sonraki sayfa" title="Sonraki sayfa" disabled={!pdf || pageNumber >= pdf.numPages || rendering} onClick={() => setPageNumber(p => p + 1)} className="p-1.5 rounded hover:bg-slate-300 dark:hover:bg-slate-700 disabled:opacity-30 transition-colors"><ChevronRight className="w-4 h-4" /></button>
      {rendering && <Loader2 data-testid="tailor-preview-loading" className="w-4 h-4 animate-spin" />}
    </div>
    {error ? <p role="alert" data-testid="tailor-preview-error" className="p-4 bg-red-50 text-red-800 text-sm break-words">Önizleme açılamadı. PDF İndir düğmesinden belgeye ulaşabilirsiniz. {error}</p> :
      <canvas ref={canvasRef} role="img" aria-label={`Terzi föyü, sayfa ${pageNumber}`} data-testid="tailor-pdf-canvas" data-ready={!rendering && Boolean(pdf)} className="block w-full max-w-[794px] h-auto mx-auto bg-white shadow-md" />}
  </div>;
};